import 'babel-polyfill';
import Vue from 'vue';
import App from '@/App.vue';
import Component from "vue-class-component";
import ElementUI from "element-ui";
import Router from "vue-router";

import router from "./router"; // ·������
import store from "./store/index";
import service from "./utils/https";
import apis from "./utils/apis";

// ȫ��ע����
Vue.use(Router);
Vue.use(ElementUI); // ���� element ���

Vue.use(ElementUI.Loading.directive);
Vue.prototype.$message = ElementUI.Message;
Vue.prototype.$loading = ElementUI.Loading.service;
Vue.prototype.$https = service; // ����ҳ����ʹ�� axios ��ʱ��ֱ��  this.$https �Ϳ�����
Vue.prototype.$apis = apis; // ����ҳ����ʹ�� urls ��ʱ��ֱ��  this.$apis �Ϳ�����
Vue.prototype.HOME = '/api'; //��Ҫ�������Vue.prototype.HOME = '/api'��һ����ֵ��Ĭ��ָ��localhost�������޸�ָ��·��Ϊ'/api'�������ļ�index.js����Ŀɿ���·��

Vue.config.productionTip = true;

/**
 * �жϵ�ǰ�Ƿ��¼��δ��¼������ת·��
 * ��ֹδ��¼״̬��ֱ������·����ת
 */
/* eslint-disable no-new */
router.beforeEach((to, from, next) => {
    if (to.path == "/helpme") {
        store.state.help = true;
        next({ path: '/login' });
    }

    if (to.path == '/login' || to.path == "/register" || to.path == "/reset") {
        store.state.token = "";
        next();
    }
    else {
        if (store.state.token) {

            if (store.state.needUpdatePassword && to.path != '/my/password') {
                next({
                    path: '/my/password'
                });
            } else {
                next();
            }
        } else {
            next({ path: '/login' });
        }
    }
});

// https://www.npmjs.com/package/vue-class-component#adding-custom-hooks
Component.registerHooks([
    "beforeRouteEnter",
    "beforeRouteLeave",
    "beforeRouteUpdate"
]);

new Vue({
    store,
    router,
    render: h => h(App)
}).$mount('#app');
